/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

document.addEventListener("DOMContentLoaded", function() {
  // Check if we are on a collection page and no filters are applied yet
  if (window.location.pathname.includes('/collections/') && !window.location.search.includes('filter.')) {
    // Look for the "In Stock" availability checkbox input
    // Shopify filters usually map '1' to In Stock
    const inStockCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]');
    
    if (inStockCheckbox && !inStockCheckbox.checked) {
      inStockCheckbox.click(); // Mimic user click to trigger theme AJAX reload
    }
  }
});